export enum SCREEN_SIZE {
    XS,
    MD,
    LG
}
